<template>
  <Modal class="dd-m-modal--error">
    <LogoIcon width="32"></LogoIcon>
    <strong>Erro</strong>
    <slot></slot>
  </Modal>
</template>

<script>
import Modal from './Modal.vue';
import LogoIcon from '../LogoIcon.vue';

export default {
  components: {
    Modal,
    LogoIcon
  }
};
</script>

<style lang="scss">
@keyframes scale {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.2);
  }
}
.dd-m-modal--error {
  .dd-m-modal-content {
    width: 90%;
    max-width: 400px;
    padding: 32px 48px;
    border-radius: 16px;
    background-color: #fff;
    border-top: 6px solid var(--color-assertive);
    box-shadow: 0 4px 16px rgba(var(--color-black), 0.1);

    p {
      text-align: center;
      font-size: 18px;
      color: var(--color-positive-normal);
    }

    strong {
      display: block;
      margin-top: 24px;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      display: block;
      font-size: 24px;
      margin-bottom: 8px;
      font-weight: 600;
      color: var(--color-positive-normal);
    }
  }
}
</style>
